import React, { useEffect, useState } from 'react'
import objectPath from 'object-path'
import { debounceCallback } from 'utility/debounceCallback.util'
import { Col, Form, Row } from 'react-bootstrap'

const AverageSample = (props) => {
  const { chart, dataSource } = props
  const title = objectPath.get(chart, 'options.title.content') || props?.title
  const [firstRender, setFirstRender] = useState(true)
  const { averageKey } = dataSource || {}
  const average = averageKey && objectPath.get(chart, 'average')
  const averageOptions = objectPath.get(chart, 'options.average') || {}

  useEffect(() => {
    debounceCallback(
      setFirstRender,
      [false],
      `render-average-${averageKey}`,
      200
    )
  }, [averageKey])

  if (averageKey && average !== undefined) {
    return (
      <div
        className="d-flex justify-content-center py-2 mt-3"
        style={{
          opacity: firstRender ? '0' : '100%',
          transition: 'all .5s ease-in-out',
          backgroundColor: averageOptions?.bgColor,
        }}
      >
        <Row
          className="w-100"
          style={{
            color: averageOptions?.fontColor || '#000',
          }}
        >
          <Col sm="12" className="d-flex justify-content-center">
            <Form.Label
              className="font-weight-bold mb-0"
              style={{ fontSize: `${averageOptions?.valueSize || 48}px` }}
            >
              {averageOptions?.prefixValue}
              {average}
              {averageOptions?.suffixValue}
            </Form.Label>
          </Col>
          <Col sm="12" className="d-flex justify-content-center">
            <Form.Label
              style={{ fontSize: `${averageOptions?.titleSize || 16}px` }}
            >
              Average {title}
            </Form.Label>
          </Col>
        </Row>
      </div>
    )
  }

  return <></>
}

export default AverageSample
